// Custom GraphQL operations for File Cabinet feature

// Queries
export const listFoldersByClient = /* GraphQL */ `
  query ListFoldersByClient(
    $clientID: ID!
    $limit: Int
    $nextToken: String
  ) {
    foldersByClient(
      clientID: $clientID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        subFolders {
          items {
            id
            name
            description
            depth
            itemCount
            lastActivityAt
          }
        }
      }
      nextToken
    }
  }
`;

export const getFolderWithContents = /* GraphQL */ `
  query GetFolderWithContents($id: ID!) {
    getFILECABINETFOLDER(id: $id) {
      id
      name
      description
      parentFolderID
      clientID
      organizationID
      createdBy
      sortOrder
      depth
      itemCount
      lastActivityAt
      createdAt
      updatedAt
      parentFolder {
        id
        name
      }
      subFolders {
        items {
          id
          name
          description
          depth
          itemCount
          lastActivityAt
          createdAt
        }
      }
      folderItems {
        items {
          id
          certificateID
          documentID
          documentType
          documentName
          addedBy
          createdAt
        }
      }
    }
  }
`;

export const listFolderItems = /* GraphQL */ `
  query ListFolderItems(
    $folderID: ID!
    $limit: Int
    $nextToken: String
  ) {
    itemsByFolder(
      folderID: $folderID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
        certificateID
        documentID
        documentType
        documentName
        clientID
        addedBy
        createdAt
      }
      nextToken
    }
  }
`;

export const checkItemInFolders = /* GraphQL */ `
  query CheckItemInFolders(
    $certificateID: ID!
    $limit: Int
    $nextToken: String
  ) {
    itemsByCertificate(
      certificateID: $certificateID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
      }
      nextToken
    }
  }
`;

// Mutations
export const createFolder = /* GraphQL */ `
  mutation CreateFolder(
    $input: CreateFILECABINETFOLDERInput!
    $condition: ModelFILECABINETFOLDERConditionInput
  ) {
    createFILECABINETFOLDER(input: $input, condition: $condition) {
      id
      name
      description
      parentFolderID
      clientID
      organizationID
      createdBy
      sortOrder
      depth
      itemCount
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;

export const updateFolder = /* GraphQL */ `
  mutation UpdateFolder(
    $input: UpdateFILECABINETFOLDERInput!
    $condition: ModelFILECABINETFOLDERConditionInput
  ) {
    updateFILECABINETFOLDER(input: $input, condition: $condition) {
      id
      name
      description
      sortOrder
      lastActivityAt
      updatedAt
    }
  }
`;

export const deleteFolder = /* GraphQL */ `
  mutation DeleteFolder(
    $input: DeleteFILECABINETFOLDERInput!
    $condition: ModelFILECABINETFOLDERConditionInput
  ) {
    deleteFILECABINETFOLDER(input: $input, condition: $condition) {
      id
    }
  }
`;

export const addItemToFolder = /* GraphQL */ `
  mutation AddItemToFolder(
    $input: CreateFILECABINETITEMInput!
    $condition: ModelFILECABINETITEMConditionInput
  ) {
    createFILECABINETITEM(input: $input, condition: $condition) {
      id
      folderID
      certificateID
      documentID
      documentType
      documentName
      clientID
      addedBy
      createdAt
    }
  }
`;

export const removeItemFromFolder = /* GraphQL */ `
  mutation RemoveItemFromFolder(
    $input: DeleteFILECABINETITEMInput!
    $condition: ModelFILECABINETITEMConditionInput
  ) {
    deleteFILECABINETITEM(input: $input, condition: $condition) {
      id
    }
  }
`;

export const logFolderActivity = /* GraphQL */ `
  mutation LogFolderActivity(
    $input: CreateFILECABINETACTIVITYInput!
    $condition: ModelFILECABINETACTIVITYConditionInput
  ) {
    createFILECABINETACTIVITY(input: $input, condition: $condition) {
      id
      action
      folderID
      itemID
      itemType
      itemName
      performedBy
      details
      clientID
      organizationID
      createdAt
    }
  }
`;

export const getFolderActivities = /* GraphQL */ `
  query GetFolderActivities(
    $clientID: ID!
    $createdAt: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByClient(
      clientID: $clientID
      createdAt: $createdAt
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        action
        folderID
        itemID
        itemType
        itemName
        performedBy
        details
        createdAt
      }
      nextToken
    }
  }
`;

// Subscriptions
export const onFolderCreated = /* GraphQL */ `
  subscription OnFolderCreated($clientID: ID!) {
    onCreateFILECABINETFOLDER(
      filter: { clientID: { eq: $clientID } }
    ) {
      id
      name
      description
      parentFolderID
      clientID
      depth
      itemCount
      createdAt
    }
  }
`;

export const onFolderUpdated = /* GraphQL */ `
  subscription OnFolderUpdated($clientID: ID!) {
    onUpdateFILECABINETFOLDER(
      filter: { clientID: { eq: $clientID } }
    ) {
      id
      name
      description
      itemCount
      lastActivityAt
      updatedAt
    }
  }
`;

export const onFolderDeleted = /* GraphQL */ `
  subscription OnFolderDeleted($clientID: ID!) {
    onDeleteFILECABINETFOLDER(
      filter: { clientID: { eq: $clientID } }
    ) {
      id
    }
  }
`;

export const onItemAddedToFolder = /* GraphQL */ `
  subscription OnItemAddedToFolder($folderID: ID!) {
    onCreateFILECABINETITEM(
      filter: { folderID: { eq: $folderID } }
    ) {
      id
      folderID
      certificateID
      documentID
      documentType
      documentName
      createdAt
    }
  }
`;

export const onItemRemovedFromFolder = /* GraphQL */ `
  subscription OnItemRemovedFromFolder($folderID: ID!) {
    onDeleteFILECABINETITEM(
      filter: { folderID: { eq: $folderID } }
    ) {
      id
    }
  }
`;